import firebase from 'firebase/app';

//functions
import { AddOrg } from '../../components/auth/signUp/functions/AddUserOrgWithSignUp/AddUserOrgWithSignUp';

export const signIn = (credentials) => {
    return (dispatch, getState, { getFirebase }) => {
        const firebase = getFirebase();

        firebase.auth().signInWithEmailAndPassword(
            credentials.email,
            credentials.password
        ).then((resp) => {
            handleCheckout(resp.user.uid)
        }).then(() => {
            dispatch({ type: 'LOGIN_SUCCESS' });
        }).catch((err) => {
            dispatch({ type: 'LOGIN_ERROR', err });
        });
    }
}

export const signOut = () => {
    return (dispatch, getState, {getFirebase}) => {
        const firebase = getFirebase();

        firebase.auth().signOut().then(() => {
            dispatch({ type: 'SIGNOUT_SUCCESS' })
        })
    }
}

export const signUp = (newUser) =>{
    return (dispatch, getState, {getFirebase, getFirestore}) =>{
        const firebase = getFirebase();
        //const firestore = getFirestore();

        firebase.auth().createUserWithEmailAndPassword(
            newUser.email,
            newUser.password
        ).then((resp)=>{
            handleCheckout(resp.user.uid)
            let authID = resp.user.uid
            handleFreeTrial(authID)
            var company = newUser.email.split("@")
            // checkForVProps(company[1])
 
            //starting profile
            handleOnboard(authID, newUser)

            emailSorting(company, newUser, resp)
        }).then(()=>{
            dispatch({type: 'SIGNUP_SUCCESS'})
        }).then(()=>{
            emailVerification()
        }).catch(err=>{
            dispatch({type: 'SIGNUP_ERROR', err})
        })
    }
}

  const handleCheckout = async(resp) =>{

    await firebase.firestore().collection('customers').doc(resp).get().then(
      function(doc)
      {
        if(doc.exists){
          //console.log("document exists")
        } else{
            var object = {
                price: 'price_1IQil9DGIrW588V86JUPexpt',
                success_url: window.location.origin,
                cancel_url: window.location.origin,
                metadata: {tokens: 1000},
                mode: "subscription",
                IdempotencyKey: "XBKifMkKaHzdvSnm",
            }
            
            firebase.firestore().collection('customers')
              .doc(resp)
              .collection('checkout_sessions')
              .doc(resp)
              .set(object)
              .then(function () {
                  //console.log('Document Added ');
              })
              .catch(function (error) {
                  //console.error('Error adding document: ', error);
              });
        }
      }
    )
}

const handleFreeTrial = async(authID) =>{

    var db = firebase.firestore();

    await db.collection('customers')
    .doc(authID)
    .collection('tokens')
    .doc(authID)
    .set({
    totalTokens: 10
    }).then(() =>{

    //put place to add to free trialed
        db.collection('freeTrial')
        .doc(authID)
        .set({
            freeTrial: 'yes'
        })
    })
  }

const emailVerification = () =>{

    var user = firebase.auth().currentUser;

    user.sendEmailVerification().then(function() {
    // Email sent.
    }).catch(function(error) {
    // An error happened.
    });
}


const emailSorting = (company, newUser, resp) =>{
    if(company[1] === "outlook.com"){
        AddOrg(newUser.email, newUser, resp.user.uid)
        return firebase.firestore().collection('users').doc(resp.user.uid).set({
            firstName: newUser.firstName,
            lastName: newUser.lastName,
            initials: newUser.firstName[0] + newUser.lastName[0],
            company: newUser.email,
            email: newUser.email,
        })
    }

    if(company[1] === "yahoo.com"){
        AddOrg(newUser.email, newUser, resp.user.uid)
        return firebase.firestore().collection('users').doc(resp.user.uid).set({
            firstName: newUser.firstName,
            lastName: newUser.lastName,
            initials: newUser.firstName[0] + newUser.lastName[0],
            company: newUser.email, 
            email: newUser.email,
        })
    }

    AddOrg(company[1], newUser, resp.user.uid)
    return firebase.firestore().collection('users').doc(resp.user.uid).set({
        firstName: newUser.firstName,
        lastName: newUser.lastName,
        initials: newUser.firstName[0] + newUser.lastName[0],
        company: company[1], 
        email: newUser.email,
    })
}

const handleOnboard = async(authID, newUser) =>{
    var db = firebase.firestore();

    await db.collection('onboards')
    .doc(authID)
    .set({
        onboarded: 'no',
        welcomeClicked: 'no',
        onboardDoneShown: 'no',
        copyMessageShown: 'no',
        messTypeShown: 'no',
        vPropShown: 'no',
        intShown: 'no',
        customInt: "no",
        fireShown: "no",
        copyShow: "no",
        generateShown: 'no',
        createdAt: new Date(),
        email: newUser.email,
    })
  }